import {connect} from 'react-redux';
import {Undo as Component} from './Undo';
import {
  showModal,
  undo
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    task: state.notebook.protocolSection.scene.focusedTaskObj,
    restarts: state.notebook.protocolSection.scene.undo.attempts,
    lastState: state.notebook.protocolSection.scene.undo.snapshots.back1,
    snapshots: state.notebook.protocolSection.scene.undo.snapshots,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    undo: (data) => {
      dispatch(undo(data))
    }
  };
}

export const Undo = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
